import {createApiQuery} from './api';
import {GetAccountEnrichmentRedemptions} from '../../shared/api/definitions/root';

export const AccountEnrichmentRedemptionKeys = {
  all: ['accountEnrichmentRedemptions'] as const,
  list: (offset?: number) =>
    [...AccountEnrichmentRedemptionKeys.all, offset ?? 0] as const,
};

export const useAccountEnrichmentRedemptions = createApiQuery(
  GetAccountEnrichmentRedemptions,
  ({offset}) => AccountEnrichmentRedemptionKeys.list(offset)
);
